<div class="pane {{ type }}">
	<h2 class="title"><i class="fa fa-{{icon}}"></i> {{title}} </h2>

	<div class="contents" [innerHTML]="contents"></div>
	
	<div class="buttons right">
		<div *ngIf="showCopy" class="button margin submit" (click)="copy()" ><i class="fa fa-copy"></i>{{ 'COPY' | translate }}</div>
		<div class="button margin submit" [ngClass]="{'disabled': confirmed}" (click)="confirm()">{{ 'OK' | translate }}</div>
	</div>

</div>